export class TrainingSequence {
    constructor(id, name, stages, precondition) {
        this.id = id;
        this.name = name;
        this.stages = stages;
        this.precondition = precondition;
    }
    hasStage(stageId) {
        return this.stages.some(stage => stage.id === stageId);
    }
}
